import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Spinner } from 'react-bootstrap';

const Search = () => {
    const [searchParams] = useSearchParams();
    const query = searchParams.get("q") || "";
    const [results, setResults] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const [search, setSearch] = useState("");

    const handleSearch = (e) => {
        if (e.key === 'Enter' && search.trim() !== '') {
            navigate(`/search?q=${encodeURIComponent(search.trim())}`);
        }
    };

    const fullUrl = (path) => {
        if (!path) return null;
        return path.startsWith("http") ? path : `https://fantasyworldtrpg.cz${path}`;
    };

    useEffect(() => {
        const fetchResults = async () => {
            if (!query) return;
            setLoading(true);

            try {
                const res = await fetch("https://api.fantasyworldtrpg.cz/echo/search_users.php", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ query }),
                });
                const data = await res.json();
                if (data.status === "success") {
                    setResults(data.users);
                } else {
                    setResults([]);
                }
            } catch (err) {
                console.error("Chyba při hledání:", err);
                setResults([]);
            } finally {
                setLoading(false);
            }
        };

        fetchResults();
    }, [query]);

    return (
        <div className="container py-5 my-5">
            <h3 className="mb-4">Výsledky hledání pro: <span className="text-danger">{query}</span></h3>
            <div className="col-12 col-md-3 mb-3">
                <div className="mb-4">
                    <div className="position-relative d-flex">
                        <i className="bi bi-search position-absolute"
                           style={{left: 10, top: '50%', transform: 'translateY(-50%)', color: '#aaa'}}></i>
                        <input
                            type="search"
                            className="form-control ps-5"
                            placeholder="Hledat"
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                            onKeyDown={handleSearch}
                        />
                        <button
                            className="btn btn-danger ms-2"
                            onClick={() => {
                                if (search.trim()) navigate(`/search?q=${encodeURIComponent(search.trim())}`);
                            }}
                        >
                            Hledat
                        </button>
                    </div>
                </div>
            </div>
                {loading ? (
                    <Spinner animation="border"/>
                ) : (
                    <>
                        {results.length === 0 ? (
                            <p className="text-secondary">Žádné výsledky.</p>
                        ) : (
                            results.map((user) => (
                                <div
                                    key={user.id}
                                    className="d-flex align-items-center mb-3 border-bottom pb-2"
                                    style={{cursor: "pointer"}}
                                    onClick={() => navigate(`/profile/${user.id}`)}
                                >
                                    <img
                                        src={fullUrl(user.img)}
                                        alt={user.name}
                                        className="rounded-circle me-3"
                                        style={{width: 50, height: 50, objectFit: "cover"}}
                                    />
                                    <strong>{user.name}</strong>
                                </div>
                            ))
                        )}
                    </>
                )}
            </div>
            );
            };

            export default Search;
